<template>
    <div class="missionBox">
        <div class="mission limited-time flexH width">
            <h3 class="mission-title">限時任務</h3>
            <div class="center-overlay">
                <a href="#" @click.prevent="$router.push('/limited-time-mission-detail')">
                    <div class="logo-block">
                        <img class="limited-mission-icon" src="@/assets/icon/uide/LimitedTimeMission-Stpes.svg" />
                    </div>
                    <div class="fM">
                        2026{{ $t('limited-time-mission.title', '決戰BMI要你走7000') }}
                    </div>
                </a>
            </div>
        </div>
    </div>

</template>
<script>
export default{
    name: 'LimitedTimeMission'
}
</script>
<style lang="scss" scoped>
.missionBox {
    width: 100%;
}

.body .index .mission {
    background-color: #ece5ff;
    padding: 24px 12px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 10px;
    position: relative;
    
    .button-item {
        display: block;
        height: 100px;
        margin-bottom:0;
        width: 100%;
        &.invisible {
            visibility: hidden;
        }
    }
    
    .center-overlay {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    .center-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        cursor: pointer;
        width: 100%;
        height: 100%;
        padding: 20px;
    }
    
    .logo-block{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;
        flex: 1;
        width: 100%;
        img {
            width: 100%;
            height: 100%;
            max-width: 120px;
            max-height: 120px;
            object-fit: contain;
        }
        .limited-mission-icon {
            width: 94px;
            height: 88px;
            max-width: none;
            max-height: none;
        }
    }
    
    .fM{
        text-align: center;
        font-weight: 400;
        line-height: 1.4;
        color: #333;
    }
}

</style>
